export const TermYears = {
  '1': null,
  '2': null,
  '3': null,
  '4': null,
  '5': null,
};

export type TTermLengthYears = keyof typeof TermYears;

  export interface ITcoNewPrice {
    updatedBy: string;
    updatedAt: string;
    productId: string;
    term: TTermLengthYears;
    price: number;
  }
  
  export interface ITcoPrice extends ITcoNewPrice {
    id: string;
    createdAt: string;
    updatedAt: string;
  }
  